// Module
var code = `<style>
    .menu-collapse-icon {
        top: 5px;
        font-size: 20px;
        color: #b2bfdc;
        cursor: pointer;
        right: 10px;
    }
    .menu-collapse-icon:hover {
        color: #fff;
    }
    .collapsing {
        -webkit-transition: none;
        transition: none;
        display: none;
    }
</style>

<div id="sidebar-wrapper">
    <ul class="sidebar">
        <li class="sidebar-main">
            <a ng-click="toggleSidebar()">
                <span class="menu-brand"></span>
                <span class="menu-toggle-icon"></span>
            </a>
        </li>
        <li>
            <form class="form-group has-feedback" style="display: flex; margin: 10px; margin-left: 20px">
                <input
                    ng-model="\$root.\$menu_filter"
                    ng-change="filter_menu(\$root.\$menu_filter)"
                    placeholder="Menu item"
                    class="form-control"
                    id="menu_filter"
                    type="text"
                />
                <span
                    ng-if="\$root.\$menu_filter"
                    ng-click="filter_menu('')"
                    class="glyphicon glyphicon-remove form-control-feedback"
                    style="cursor: pointer; pointer-events: all; margin-right: 50px"
                ></span>
                <span
                    ng-click="toggle_menu_collapse()"
                    class="glyphicon menu-collapse-icon"
                    ng-class="\$root.is_menu_collapsed ? 'glyphicon-resize-full': 'glyphicon-resize-small'"
                ></span>
            </form>
        </li>
        <li ng-repeat-start="m in \$menu | orderBy:'priority':true"
            class="sidebar-list"
            ng-class="{'active': \$state.includes(m.state)}"
            ng-if="\$current_user.can(m.role)">

            <a ng-if="!m.childs && !m.abstract"
               ui-sref="{{m.state}}"
               ui-sref-opts="{inherit: true}"
               id="left_menu.{{m.state}}"

            >
                {{m.title}}
                <span ng-if="m.glyphicon" class="menu-icon glyphicon glyphicon-{{m.glyphicon}}"></span>
                <span ng-if="m.fa" class="menu-icon fa fa-{{m.fa}}"></span>
            </a>

            <a ng-if="m.childs && m.abstract" ng-init="m.is_collapsed = !\$state.includes(m.state)"
               ng-click="m.is_collapsed = !m.is_collapsed" id="left_menu.{{m.state}}">
                {{m.title}}
                <span ng-if="m.glyphicon" class="menu-icon glyphicon glyphicon-{{m.glyphicon}}"></span>
                <span ng-if="m.fa" class="menu-icon fa fa-{{m.fa}}"></span>
            </a>
        </li>
        <div uib-collapse="m.is_collapsed" ng-if="m.childs && \$current_user.can(m.role)">
            <li ng-repeat="sch in m.childs | orderBy:'priority':true"
                ng-if="sch.state && \$current_user.can(sch.role)"
                ui-sref-active="active"
                class="sidebar-list-level2">
                <a ui-sref="{{ sch.state }}(sch.state_params)"
                   ui-sref-opts="{inherit: true}"
                   id="left_menu.{{sch.state}}"
                >
                    <span>{{ sch.title }}</span>
                    <span ng-if="sch.glyphicon" class="menu-icon glyphicon glyphicon-{{sch.glyphicon}}"></span>
                    <span ng-if="sch.fa" class="menu-icon fa fa-{{sch.fa}}"></span>
                </a>
            </li>
        </div>
        <div ng-repeat-end></div>
    </ul>

</div>
`;
// Exports
module.exports = code;